import React, {Component} from 'react'
import Base from '../BaseComponent'

import Media from '../Media'
import {TweenLite} from 'gsap';
import {OverlayView} from 'react-google-maps';
import Content from '../Content'


class CustomOverlay extends Component {

    defStyle = {
    			position: 'absolute',
                width: '220px',
                height: '250px',
                backgroundColor: '#000000',
                cursor: 'pointer',
                fontFamily: '"Fenway Regular", helvetica, sans-serif',
                fontSize: '16px',
                color: '#FFC03B',
                opacity: 0,
                top: '-250px',
                left: '20px',
                transition: 'opacity 0.3s ease-out'
            }

    constructor(props)
    {
        super(props)

        



        
    }

    componentDidMount()
    {
        let _this = this;

    }

    mouseOver = () => {
    }

    mouseOut = () => {
        
    }

   	getPixelPositionOffset = (width, height) => ({
	  x: 0,
	  y: -(height),
	})

  render () {
    
    //console.log('CustomOverlay render',this.state.defStyle)

    return (
        <OverlayView
        	getPixelPositionOffset={this.getPixelPositionOffset}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            position={this.props.position}>
            <div>
            <div ref="panel" className="OverlayView" style={{opacity:this.props.opacity, top:this.props.top}}>
            	<Media id={this.props.image} fluid={false}/>
                <Content html={"<p style="+{padding:'10px'}+">" + this.props.title + "</p>"}/>
            	
            	
            </div></div>
        </OverlayView>
    );
    };
}


export default CustomOverlay;


// WEBPACK FOOTER //
// ./src/js/components/CustomOverlay/CustomOverlay.jsx